export default __webpack_public_path__ + "static/media/arrow_forward_blue_24dp@2x.02523fd6.png";